import 'ol/ol.css';
import ImageLayer from 'ol/layer/Image.js';
import Projection from 'ol/proj/Projection.js';
import {fromLonLat} from 'ol/proj';
import {LonLat} from 'ol/proj';
import {toLonLat} from 'ol/proj';
import Static from 'ol/source/ImageStatic.js';
import {Map, View, Feature} from 'ol';
import {getCenter} from 'ol/extent.js';
import TileLayer from 'ol/layer/Tile.js';
import OSM from 'ol/source/OSM.js';
import MousePosition from 'ol/control/MousePosition.js';
import {createStringXY} from 'ol/coordinate.js';
import {Control, defaults as defaultControls} from 'ol/control.js';
import sourceVector from 'ol/source/Vector.js';
import layerVector from 'ol/layer/Vector.js';
import LineString from 'ol/geom/LineString.js';
import Polygon from 'ol/geom/Polygon';
import Circle from 'ol/geom/Circle.js';
import {Fill, Stroke, Style, Text} from 'ol/style.js';
import {log, abs, round, pow, sin, cos, pi, floor} from 'mathjs';
import * as tephi from './modules/Tephigramme.js';
import * as get_wms_data from './modules/get_wms_data.js';
import { GridPointMarkers } from './modules/map_markers.js';

export {Feature, LineString, Polygon, sourceVector, layerVector, Circle, Fill, Stroke, Style, Text, log, abs, round, pow, sin, cos, pi, floor, tephi_map_minzoom, tephi_map_maxzoom};

const levels = [100,150,175,200,225,250,275,300,350,400,450,500,550,600,650,700,750,800,850,875,900,925,950,970,985,1000,1015];

const message_datev="Date validit&eacute, le menu sera mise a jour apr&egrave;s la selection du mod&egrave;le"

document.getElementById('hamburger').onclick = function() {
  document.getElementById("mySidenav").style.width = "250px";
  document.getElementById("main").style.marginLeft = "250px";
}
document.getElementById("x_to_close_side").onclick = function() {
  document.getElementById("mySidenav").style.width = "0";
  document.getElementById("main").style.marginLeft= "0";
}

// Map views always need a projection.  Here we just want to map image
// coordinates directly to map coordinates, so we create a projection that uses
// the image extent in pixels.
var extent = [0, 0, 3300, 2550];
var projection = new Projection({
  code: 'xkcd-image',
  units: 'pixels',
  extent: extent,
});

var mousePositionControl = new MousePosition({
  coordinateFormat: createStringXY(4),
  projection:  projection,
  // comment the following two lines to have the mouse position
  // be placed within the map.
  //className: 'custom-mouse-position',
  //target: document.getElementById('tephi'),
  undefinedHTML: '&nbsp;',
});

var tephi_map_minzoom=2;
var tephi_map_maxzoom=5;
var tephi_map = new Map({
  controls: defaultControls().extend([mousePositionControl]),
  layers: [
    new ImageLayer({
      source: new Static({
	url: 'https://imeteo.ca/html/images/tephi_complet_20_dpi.jpg',
        projection: projection,
        imageExtent: extent,
      }),
    }) ],
  target: 'id_tephi',
  view: new View({
    projection: projection,
      center: [2500, 500],
    zoom: 3,
    minZoom: tephi_map_minzoom,
    maxZoom: tephi_map_maxzoom,
  }),
});

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    // Zoom over sourthern Quebec.
    center: fromLonLat([-74., 45.]),
    zoom: 6
  })
});

var tephi_control = new tephi.Tephi_control({
  id_plot_wind:         document.getElementById('id_plot_wind'),
  id_model:             document.querySelector('.id_model'),
  id_datev_message:     document.getElementById('id_datev_message'),
  id_datev_menu:        document.getElementById('id_datev_menu'),
  id_temp:              document.getElementById('id_temp'),
  id_T_max_level:       document.getElementById('id_T_max_level'),
  id_T_min_level:       document.getElementById('id_T_min_level'),
  id_td:                document.getElementById('id_td'),
  id_Td_max_level:      document.getElementById('id_Td_max_level'),
  id_Td_min_level:      document.getElementById('id_Td_min_level'),
  id_wind:              document.getElementById('id_wind'),
  id_V_max_level:       document.getElementById('id_V_max_level'),
  id_V_min_level:       document.getElementById('id_V_min_level'),
  id_message:           document.getElementById('id_message'),
  id_plot_wind_val:     document.getElementById('id_plot_wind_val'),
  id_height_no:         document.getElementById('id_height_no'),
  id_height_agl:        document.getElementById('id_height_agl'),
  id_height_asl:        document.getElementById('id_height_asl'),
  id_product_displayed: document.getElementById('id_product_displayed'),
  levels:               levels
});

var mytephi = new tephi.Tephigramme(
  tephi_map,
  'OpenLayers',
  tephi_control,
  'https://imeteo.ca/imeteo');

var markers = new GridPointMarkers(map);
var wms_req = new get_wms_data.WMS_request(tephi_control,levels,markers);

// Bouton "Effacer les points passés", affiché sur la carte sous le zoom
// +/- (même emplacement/style que les contrôles OpenLayers standards),
// en plus de celui de la barre latérale.
class ClearPastControl extends Control {
  constructor(opt_options){
    var options = opt_options || {};
    var button = document.createElement('button');
    button.innerHTML = '&#128465;';
    button.title = 'Effacer les points passés';
    var element = document.createElement('div');
    element.className = 'clear-past-control ol-unselectable ol-control';
    element.appendChild(button);
    super({element: element, target: options.target});
    button.addEventListener('click', () => wms_req.clear_past());
  }
}
map.addControl(new ClearPastControl());

// Make mytephi available in index.html
window.mytephi = mytephi

var g1 = new tephi.Tephi_reference_points(
  0., 290., 2314.05,  368.6,
  0., 350., 2877.7, 1008.5,
  20.,290., 2605.3,  110.9);
mytephi.add_reference_points(g1,-15.,500.);
//mytephi.plot_reference_lines(g1);

var g2 = new tephi.Tephi_reference_points(
  -30., 310., 2075.8,  981.7,
  -30., 440., 3125.8, 2176.7,
  -65., 310., 1566.9, 1433.1);
mytephi.add_reference_points(g2,-40.,-15.);
//mytephi.plot_reference_lines(g2);

var g3 = new tephi.Tephi_reference_points(
  -50., 320., 1880.5, 1347.9,
  -50., 410., 2623.7, 2193.2,
  -75., 320., 1516.9, 1669.6);
mytephi.add_reference_points(g3,-100.,-40.);
//mytephi.plot_reference_lines(g3);

//mytephi.plot_control_points();
//mytephi.segment_text([[2000,1000],[2100,1000]]);

//var temp=[10.,5.0,0.,];
//var td=[8.,5.0,-10.,];
//var levs=[1000.,850.0,700.,];
//mytephi.plot_profile(temp,levs,'red');
//mytephi.plot_profile(td,levs,'blue');

//var levs     = [1000,  950,  900,  850,  800,  750,  700,  650,  600,  550,  500,  450,  400,  350,  300,  250,  200];
//var force    = [   0,    5,   10,   15,   20,   25,   30,   35,   40,   45,   50,   55,   60,  100,  155,  235,  300];
//var wind_dir = [   0, 22.5, 45.0, 67.5, 90.0,112.5,135.0,157.5,180.0,202.5,225.0,247.5,270.0,292.5,315.0,337.5,360.0];
//mytephi.plot_winds(force,wind_dir,levs,20.,'black');

var hasSelectedPoint = false;
var pendingMarker = null;

// Un seul marqueur temporaire à la fois : si un point précédent n'a jamais
// déclenché de requête (ex. point restauré au chargement, puis l'utilisateur
// clique ailleurs avant de choisir une date), son cercle resterait sinon
// affiché indéfiniment sur la carte.
function setPendingMarker(lonLat){
  if(pendingMarker){
    pendingMarker.clear();
  }
  pendingMarker = markers.pending(lonLat);
  return pendingMarker;
}

map.on('click', function(evt){
  mytephi.clear_profile();
  var coords = toLonLat(evt.coordinate);
  wms_req.lat = coords[1];
  wms_req.lon = coords[0];
  if(mytephi.tephi_control.get_model() == "UNDEF"){
    alert("Vous devez choisir un modèle avec le menu en haut à gauche");
    return;
  }
  wms_req.model=mytephi.tephi_control.get_model();
  wms_req.tephi_control.cre_cook('lat',wms_req.lat);
  wms_req.tephi_control.cre_cook('lon',wms_req.lon);
  hasSelectedPoint = true;
  setPendingMarker([wms_req.lon,wms_req.lat]);
  wms_req.get_data(pendingMarker);
});

var currZoom = tephi_map.getView().getZoom();
tephi_map.on('moveend', function(e) {
  var newZoom = tephi_map.getView().getZoom();
  if (currZoom != newZoom) {
    //alert('zoom end, new zoom: ' + newZoom);
    currZoom = newZoom;
  }
});


window.addEventListener('load', (event) => {
  wms_req.tephi_control.id_datev_message.innerHTML=message_datev;
  build_level_menu("id_T_max_level",true)
  build_level_menu("id_Td_max_level",true)
  build_level_menu("id_V_max_level",true)
  build_level_menu("id_T_min_level")
  build_level_menu("id_Td_min_level")
  build_level_menu("id_V_min_level")
  for(let i=0; i < levels.length; i++){
    if(levels[i] <= 600){
      document.getElementById("id_T_min_level").selectedIndex=i;
    }
    if(levels[i] <= 600){
      document.getElementById("id_Td_min_level").selectedIndex=i;
    }
    if(levels[i] <= 600){
      document.getElementById("id_V_min_level").selectedIndex=i;
    }
  }
  document.getElementById("id_T_max_level").selectedIndex=levels.length;
  document.getElementById("id_Td_max_level").selectedIndex=levels.length;
  document.getElementById("id_V_max_level").selectedIndex=levels.length;
  var lat=wms_req.tephi_control.lit_cook('lat');
  var lon=wms_req.tephi_control.lit_cook('lon');
  if(lat != "" && lon != ""){
    wms_req.lat = lat;
    wms_req.lon = lon;
    hasSelectedPoint = true;
    setPendingMarker([lon,lat]);
  } else {
    lat = 45.;
    lon = -74.;
  }
  map.getView().setCenter(fromLonLat([parseFloat(lon), parseFloat(lat)]));
  wms_req.tephi_control.init_from_cookies();
  wms_req.model=tephi_control.get_model();
  wms_req.get_fcst_dates(lat,lon);
  tephi_control.id_datev_message.innerHTML=wms_req.model+", DateV "
});

function build_level_menu(id,sfc=false){   
  const menu = document.getElementById(id);
  var list = [...levels];
  if(sfc){
    list.push('Surface');
  }
  for(let i=0; i < list.length; i++){
    let option = document.createElement("option");
    option.setAttribute('value', list[i]);
    let unit=" hPa";
    if(list[i] == 'Surface'){
      unit="";
    }
    let optionText = document.createTextNode(list[i]+unit);
    option.appendChild(optionText);
    menu.appendChild(option);
  }
}

document.querySelector('.id_model').addEventListener('change', (event) => {
  if(event.target.value == "UNDEF"){
    wms_req.clear_datev_menu();
    wms_req.tephi_control.id_datev_message.innerHTML=message_datev;
  }else{
    wms_req.tephi_control.set_cook_from_id('id_model');
    id_datev_message.innerHTML=event.target.value+", DateV "
    var lat=wms_req.tephi_control.lit_cook('lat');
    var lon=wms_req.tephi_control.lit_cook('lon');
    if(lat != "" && lon != ""){
      wms_req.lat = lat;
      wms_req.lon = lon;
      hasSelectedPoint = true;
      setPendingMarker([lon,lat]);
    } else {
      lat = 45.;
      lon = -70.;
    }
    wms_req.get_fcst_dates(lat,lon);
  }
});

document.getElementById('id_clear_past').addEventListener('click', function() {
  wms_req.clear_past();
});

// I tried to put this in a look with an array, but it dd not work.
document.getElementById('id_temp').addEventListener('change', (event) => {
  wms_req.tephi_control.check_td_levels();
  wms_req.tephi_control.set_cook_from_id('id_temp');
});
document.getElementById('id_td').addEventListener('change', (event) => {
  wms_req.tephi_control.check_td_levels();
  wms_req.tephi_control.set_cook_from_id('id_td');
});
document.getElementById('id_wind').addEventListener('change', (event) => {
  wms_req.tephi_control.set_cook_from_id('id_wind');
});
document.getElementById('id_plot_wind_val').addEventListener('change', (event) => {
  wms_req.tephi_control.set_cook_from_id('id_plot_wind_val');
});
document.getElementById('id_height_no').addEventListener('change', (event) => {
  wms_req.tephi_control.set_cook_from_id('id_height_no');
});
document.getElementById('id_height_agl').addEventListener('change', (event) => {
  wms_req.tephi_control.set_cook_from_id('id_height_agl');
});
document.getElementById('id_height_asl').addEventListener('change', (event) => {
  wms_req.tephi_control.set_cook_from_id('id_height_asl');
});
document.getElementById('id_T_max_level').addEventListener('change', (event) => {
  wms_req.tephi_control.check_td_levels()
  wms_req.tephi_control.set_cook_from_id('id_T_max_level');
});
document.getElementById('id_T_min_level').addEventListener('change', (event) => {
  wms_req.tephi_control.check_td_levels()
  wms_req.tephi_control.set_cook_from_id('id_T_min_level');
});
document.getElementById('id_Td_max_level').addEventListener('change', (event) => {
  wms_req.tephi_control.check_td_levels();
  wms_req.tephi_control.set_cook_from_id('id_Td_max_level');
});
document.getElementById('id_Td_min_level').addEventListener('change', (event) => {
  wms_req.tephi_control.check_td_levels();
  wms_req.tephi_control.set_cook_from_id('id_Td_min_level');
});
document.getElementById('id_V_max_level').addEventListener('change', (event) => {
  wms_req.tephi_control.set_cook_from_id('id_V_max_level');
});
document.getElementById('id_V_min_level').addEventListener('change', (event) => {
  wms_req.tephi_control.set_cook_from_id('id_V_min_level');
});

document.getElementById('id_datev_menu').addEventListener("change", function() {
  if(!hasSelectedPoint){
    alert('Choisir un point sur la carte');
    return;
  }
  wms_req.get_data(pendingMarker);
});

document.getElementById('id_dec_datev').addEventListener("click", function() {
  if(!hasSelectedPoint){
    alert('Choisir un point sur la carte');
    return;
  }
  var id_inc=document.getElementById('id_datev_increment');
  var delta=parseInt(id_inc[id_inc.selectedIndex].value);
  var datev_menu=document.getElementById('id_datev_menu');
  var ind=datev_menu.selectedIndex-delta;
  wms_req.model=mytephi.tephi_control.get_model();
  if(ind < 0){
    ind=datev_menu.length-1;
  }
  datev_menu.selectedIndex=ind;
  wms_req.get_data(pendingMarker);
});

document.getElementById('id_inc_datev').addEventListener("click", function() {
  if(!hasSelectedPoint){
    alert('Choisir un point sur la carte');
    return;
  }
  var id_inc=document.getElementById('id_datev_increment');
  var delta=parseInt(id_inc[id_inc.selectedIndex].value);
  var datev_menu=document.getElementById('id_datev_menu');
  var ind=datev_menu.selectedIndex+delta;
  wms_req.model=mytephi.tephi_control.get_model();
  if(ind >= datev_menu.length){
    ind=0;
  }
  datev_menu.selectedIndex=ind;
  wms_req.get_data(pendingMarker);
});

export {mytephi}
